module.exports = __webpack_public_path__ + "static/media/25handle.13442d9d.png";